module.exports = __webpack_public_path__ + "static/media/add_weld_error.2232472a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/add_weld_error.jpg
// module id = 1859
// module chunks = 0